import { actionCreatorFactory } from '@core/utils/factories';
import {
  PaginatedResponse,
  ProceccedSiteAuditRaycapsData,
  ProcessEnvMap as KeyString,
  SiteAuditBrowse,
  SiteAuditCablesData,
  SiteAuditDetails,
} from '@models/interfaces';

const actionCreator = actionCreatorFactory('SITE_AUDIT');

export namespace SiteAuditActions {
  export const getSiteAuditBrowseDataAction = actionCreator.createAsyncAction<
    PaginatedResponse<SiteAuditBrowse>
  >('GET_SITE_AUDIT_BROWSE');
  export const updateSiteAuditBrowseDataAction =
    actionCreator.createAsyncAction<PaginatedResponse<SiteAuditBrowse>>(
      'UPDATE_SITE_AUDIT_BROWSE',
    );
  export const getSiteAuditDetailsAction =
    actionCreator.createAsyncAction<SiteAuditDetails>('GET_SITE_AUDIT_DETAILS');
  export const updateSiteAuditDetailsAction =
    actionCreator.createAsyncAction<SiteAuditDetails>(
      'UPDATE_SITE_AUDIT_DETAILS',
    );
  export const setCablesAction = actionCreator.createAsyncAction<
    SiteAuditCablesData[]
  >('CLEAR_SITE_AUDIT_CABLES');
  export const addCableItemAction =
    actionCreator.createAsyncAction<SiteAuditCablesData>(
      'ADD_SITE_AUDIT_CABLE_ITEM',
    );
  export const updateCableItemAction =
    actionCreator.createAsyncAction<SiteAuditCablesData>(
      'UPDATE_SITE_AUDIT_CABLE_ITEM',
    );
  export const deleteCableItemAction =
    actionCreator.createAsyncAction<KeyString>('DELETE_SITE_AUDIT_CABLE_ITEM');
  export const setRaycapsAction = actionCreator.createAsyncAction<
    ProceccedSiteAuditRaycapsData[]
  >('CLEAR_SITE_AUDIT_RAYCAPS');
  export const addRaycapItemAction =
    actionCreator.createAsyncAction<ProceccedSiteAuditRaycapsData>(
      'ADD_SITE_AUDIT_RAYCAP_ITEM',
    );
  export const updateRaycapItemAction =
    actionCreator.createAsyncAction<ProceccedSiteAuditRaycapsData>(
      'UPDATE_SITE_AUDIT_RAYCAP_ITEM',
    );
  export const deleteRaycapItemAction =
    actionCreator.createAsyncAction<KeyString>('DELETE_SITE_AUDIT_RAYCAP_ITEM');
}
